export default __webpack_public_path__ + "static/media/icon-services-video-archive.b676f462.svg";